<script>
import { Line, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins;

export default {
  name: 'line-chart',
  extends: Line,
  mixins: [reactiveProp],
  props: ['options'],
  mounted () {
    this.renderChart(this.chartData, this.options);
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';
</style>



// WEBPACK FOOTER //
// src/components/ui/LineChart.vue